import styled from "styled-components/macro";

export default function Visa() {
  return (
    <>
      <Background />
      <LargeCircle />
      <ClearCircle />
      <DotsHolder>
        <Dot1 />
        <Dot2 />
        <Dot3 />
      </DotsHolder>
    </>
  );
}

const Background = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: linear-gradient(to top right, #243545, #384653);
`;

const ClearCircle = styled.div`
  width: 100%;
  position: absolute;
  aspect-ratio: 1 /1;
  border: 2px solid rgba(255, 255, 255, 0.4);
  left: 35%;
  bottom: 40%;
  border-radius: 100%;
`;

const LargeCircle = styled.div`
  position: absolute;
  border-radius: 100%;
  aspect-ratio: 1;
  width: 120%;
  background-image: linear-gradient(
    to bottom left,
    rgba(74, 88, 101, 1),
    rgba(74, 88, 101, 0),
    rgba(74, 88, 101, 0)
  );
  left: 50%;
  margin-left: -60%;
  top: 12px;
`;

const DotsHolder = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
  width: 120px;
  height: 52px;
  display: flex;
  align-items: center;
  @media screen and (max-width: 1px) {
    top: auto;
    bottom: 1px;
    margin-bottom: -26px;
  }
  @media screen and (max-width: 1px) {
    bottom: 1px;
  }
`;

const Dot1 = styled.div`
  position: absolute;
  width: 48px;
  height: 48px;
  border-radius: 48px;
  background: #e91d26;
  z-index: 5;
  right: 32px;
  .width_320 & {
    width: 42px;
    height: 42px;
    right: 26px;
  }
`;
const Dot2 = styled(Dot1)`
  background: #f39e1f;
  z-index: 2;
  right: 0;
  .width_320 & {
    right: 0;
  }
`;
const Dot3 = styled(Dot2)`
  opacity: 0.6;
  z-index: 10;
`;
